// import io from 'socket.io-client';
// import config from "../actions/config"
// let socket;
// const options = {
//     init: (httpServer) => {
//             socket = io.connect(httpServer, {'forceNew':true });
//             return socket;
//     },
//     getIO: () => {
//         if (!socket) {
//             socket = io.connect(config.IMG_URL, {'forceNew':true });
//             return socket;
//             // throw new Error('Socket.io not initialized!');
//         }
//         return socket;
//     },
//     createConnection:(id)=>{
//         try {
//             if (id) {
//                 socket.io.opts.query = { _id:id }
//                 socket.disconnect()
//                 socket.connect(io)
//                 // console.log('disconnectdisconnect---->',id);
//             }
//         } catch (e) {
//             console.log('Erro on connection---->', e);
//         }
//     }
    
// };

// export default options



import io from 'socket.io-client';
import config from '../actions/config'

export const socket = io(config.IMG_URL, {
    path: '/socket.io',
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 50,
    transports: ['websocket'],
    jsonp: false,
})

export let socketId;
socket.on('connected', () => {

    socketId = socket.id
})

export const createConnection = (id) => {
    try {
        if (id) {
            socket.io.opts.query = { _id:id }
            socket.disconnect()
            socket.connect(io)
            // console.log('disconnectdisconnect---->',id);
        }
    } catch (e) {
        console.log('Erro on connection---->', e);
    }
}